import { AutomatedBreakType } from '@sdk/settings/types';

import DynamicBreakEntryRow from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AutomatedTimesheetEntries/DynamicBreakEntryRow/DynamicBreakEntryRow';
import TimesheetEntryBaseRow from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AutomatedTimesheetEntries/TimesheetEntryBaseRow/TimesheetEntryBaseRow';
import breakOrangeIcon from '@kiosk/assets/svg/icons/break-orange.svg';
import { getDisplayDuration } from '@kiosk/utils/Utils';
import { useAutomatedBreakEntries } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AutomatedTimesheetEntries/AutomatedBreakEntries/automatedBreakEntries.hooks';

type Props = {
  clockIn: Date;
  clockOut: Date;
  delay: number;
};

const AutomatedBreakEntries = ({ clockIn, clockOut, delay }: Props) => {
  const { breakRecords } = useAutomatedBreakEntries({ clockIn, clockOut });

  return (
    <>
      {breakRecords.map(item =>
        !item.inProgress ? (
          <TimesheetEntryBaseRow
            key={item.breakStartEntryId}
            icon={breakOrangeIcon as string}
            label={item.type === AutomatedBreakType.rest ? 'rest break' : 'meal break'}
            contentTxt={getDisplayDuration(item.breakDurationInMinutes)}
            delay={delay}
          />
        ) : (
          <DynamicBreakEntryRow
            key={item.breakStartEntryId}
            label={item.type === AutomatedBreakType.rest ? 'rest break' : 'meal break'}
            startTimestampLocal={item.startTimestampLocal}
            delay={delay}
          />
        )
      )}
    </>
  );
};

export default AutomatedBreakEntries;
